import { AppLink } from "utils/const";

export const downloadTheApp = () => {
  window.open(AppLink);
};
